export default "__VITE_ASSET__BP84sq8l__"